module.exports = __webpack_public_path__ + "img/experienced-hire-2.2b4b8e07.png";